import React from 'react';
import PropType from 'prop-types';

import ReactHighcharts from 'react-highcharts';
import _ from 'lodash';
import {Alert} from 'reactstrap';


class PidChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lastTitles: [this.props.title, '', ''],
      level: 0,
    };
  }

  getChartConfig(series) {
    const prefix = ['', 'Subcategories of ', 'PID diagnoses of '];
    const credits = this.props.copyright ? {
      position: {
        verticalAlign: 'middle',
        align: 'center'
      },
      style: {
        fontSize: '20px'
      }
    } : {};

    return {
      chart: {
        type: 'pie',
        events: {
          drillup: (e) => {
            const chart = this.refs[this.props.id].getChart();
            chart.setTitle({text: prefix[--this.state.level] + this.state.lastTitles[this.state.level]});
          },
          drilldown: (e) => {
            const chart = this.refs[this.props.id].getChart();
            this.state.lastTitles[++this.state.level] = e.point.name;
            chart.setTitle({text: prefix[this.state.level] + e.point.name});
          },
        }
      },
      credits,
      exporting: {enabled: this.props.exporting},
      title: {
        text: this.props.title
      },
      subtitle: {
        text: this.props.subtitle
      },
      xAxis: {
        type: 'category'
      },
      plotOptions: {
        series: {
          borderWidth: 1,
        },
        pie: {
          dataLabels: {
            enabled: true,
            format: '<b>{point.name}</b>: {point.y} ({point.percentage:.1f} %)',
            style: {
              color: (ReactHighcharts.Highcharts.theme && ReactHighcharts.Highcharts.theme.contrastTextColor) || 'black'
            }
          }
        }
      },

      tooltip: {
        pointFormat: 'Patients: {point.y} ({point.percentage:.1f}%)'
      },
      ...series
    };
  }

  getConfig(data) {
    const _generalGroupedByMainCat = _(data)
      .groupBy('main_category_id');

    return this.getChartConfig({
        series: [{
          id: 'toplevel',
          name: this.props.title,
          data: _generalGroupedByMainCat
            .map((objs, key) => {
                let result = {
                  name: objs[0].main_category,
                  y: _.sumBy(objs, 'count')
                };

                if (this.props.drillDown) result.drilldown = 'level1_' + objs[0].main_category_id;

                return result;
              }
            )
            .orderBy(['y'], ['desc'])
            .value()
        }],
        drilldown: {
          activeDataLabelStyle: {
            'cursor': 'pointer',
            'color': 'black',
            'fontWeight': 'regular',
            'textDecoration': 'none'
          },
          series:
            _generalGroupedByMainCat
              .map((objs, key) => ({
                    id: 'level1_' + objs[0].main_category_id,
                    name: objs[0].main_category,
                    data:
                      _(objs)
                        .groupBy('sub_category_id')
                        .map(
                          (objs, key) => ({
                            name: objs[0].sub_category,
                            y: _.sumBy(objs, 'count'),
                            drilldown: 'level2_' + objs[0].sub_category_id
                          })
                        )
                        .value()
                  }
                )
              ).value().concat(
              [].concat.apply([], _generalGroupedByMainCat
                .map((objs, mainId) => (
                    _(objs)
                      .groupBy('sub_category_id')
                      .map(
                        (objs, subId) =>
                          ({
                            id: 'level2_' + subId,
                            data: _(objs)
                              .groupBy('pid')
                              .map(
                                (objs, pid) =>
                                  ({
                                    name: objs[0].pid,
                                    y: _.sumBy(objs, 'count'),
                                  })
                              ).value()
                          })
                      ).value()
                  )
                ).value())
            )
        }
      }
    );
  }

  render() {
    const config = this.getConfig(this.props.data);

    return (
      <div>
        <ReactHighcharts config={config}
                         ref={this.props.id}/>
        {this.props.drillDown && <Alert color="warning">Click on a pie chart section to get a detailed distribution of the section</Alert>}
      </div>
    );
  }
}

PidChart.propTypes = {
  data: PropType.array.isRequired,
  id: PropType.string.isRequired,
  title: PropType.string.isRequired,
  drillDown: PropType.bool.isRequired,
  exporting: PropType.bool.isRequired,
  copyright: PropType.bool.isRequired
};

PidChart.defaultProps = {
  drillDown: true,
  exporting: true,
  copyright: false
};

export default PidChart;


// WEBPACK FOOTER //
// ./src/views/Statistics/PID/PIDChart.js